import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './FilterMetaLayout.scss'
import FilterModal from '../filtersRow/FilterModal'
import LayoutSelector from '../layoutSelector/LayoutSelector'
import SortableList from '../sortableList/SortableList'
import SelectedFiltersDisplay from './SelectedFiltersDisplay'
import FadeInFullscreen from '../FadeInFullscreen'
import FilterIcon from '../../../assets/codicons/filter'
import { connect } from 'react-redux'
import { applyDurationFilter } from 'redux/actions/planEntries'

class FilterMetaLayout extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      fixed: false
    }
  }

  render() {
    const filterMetaLayoutClass = classNames('FilterMetaLayout', {
      'FilterMetaLayout--fixed': this.state.fixed,
      'FilterMetaLayout--noLowerXs': this.props.noLowerXs
    })

    const filterModalButtonClass = classNames(
      'FilterMetaLayout__filterButtonLabel',
      {
        'FilterMetaLayout__filterButtonLabel--filtered ':
          this.props.userHasFiltered
      }
    )
    let mobileFilter
    let newMobileData = this.props.renderTopRow()
    if (this.props.modalFilterOptions) {
      const mobileFilterContent = this.props.renderMobileFilters ? (
        <FadeInFullscreen isOpen={this.state.isMobileFilterOpen}>
          <div className='FilterList__top'>
            <div className='FilterList__firstRow'>
              <div className='FilterList__filtersSelected'>
                {this.props.totalfiltersSelected > 0
                  ? `Filters Selected(${this.props.totalfiltersSelected})`
                  : `Filters`}
              </div>

              {/* <div
                className='FilterList__close'
                onClick={() => {this.setState({ isMobileFilterOpen: false })}}
              >
                &times;
              </div> */}
            </div>
            {this.props.totalfiltersSelected > 0 ? (
              <SelectedFiltersDisplay
                filteredItemLabels={this.props.filteredLabels}
                onLabelClick={this.props.onSelectedFilterLabelClick}
                onClearAll={this.props.onClearAll}
                isMobile={true}
              />
            ) : null}
          </div>
          {newMobileData}
          <button
            className='sticky-button'
            onClick={() => {
              this.setState({ isMobileFilterOpen: false })
              if (
                this.props.customDuration.min == null &&
                this.props.customDuration.max == null
              ) {
                return null
              }
              this.props.addCustomDuration({
                durationOptions: this.props.durationOptions
              })
            }}
          >
            View Results
          </button>
        </FadeInFullscreen>
      ) : (
        <FilterModal
          active={this.state.isMobileFilterOpen}
          filtered={this.props.filters}
          filterOptions={this.props.modalFilterOptions}
          onHide={() => this.setState({ isMobileFilterOpen: false })}
          onClear={(label) => {
            this.props.onModalClear(label)
          }}
        />
      )
      mobileFilter = (
        <React.Fragment>
          <div className='FilterMetaLayout__filterOptions'>
            <div
              className={filterModalButtonClass}
              onClick={() => this.setState({ isMobileFilterOpen: true })}
            >
              {this.props?.totalfiltersSelected > 0
                ? `Filters(${this.props.totalfiltersSelected})`
                : 'Filters'}
              <FilterIcon />
            </div>
          </div>
          {mobileFilterContent}
        </React.Fragment>
      )
    }

    let bottomContent
    if (this.props.filteredLabels) {
      bottomContent = (
        <div className='FilterMetaLayout__bottomContent'>
          {/* commenting this as part of MVS-644 class finder redesign
          <FilterRowDropdownSet filterOptions={this.props.filters} /> */}
          <div>
            <SelectedFiltersDisplay
              filteredItemLabels={this.props.filteredLabels}
              onLabelClick={this.props.onSelectedFilterLabelClick}
              onClearAll={this.props.onClearAll}
              isMobile={true}
            />
          </div>
        </div>
      )
    }

    let layoutSelector
    if (this.props.onLayoutSelect) {
      layoutSelector = (
        <LayoutSelector
          onSelect={this.props.onLayoutSelect}
          layout={this.props.layout}
        />
      )
    }

    return (
      <div className={filterMetaLayoutClass}>
        <div className='FilterMetaLayout__topContent'>
          <div className='FilterMetaLayout__topRow'>
            {this.props.renderTopRow()}
          </div>
          <div className='FilterMetaLayout__bottomRow'>
            <div className='FilterMetaLayout__bottomRowLeft'>
              {mobileFilter}
              <div className='sortable-list-container pull-right'>
                <SortableList
                  sortableFields={this.props.sortableFields}
                  order={this.props.order}
                  onSort={this.props.onSort}
                  alignLeftXs={true}
                  sortLocation={this.props.contentLabel.toLowerCase()}
                  isMobile={true}
                />
              </div>
              {layoutSelector}
            </div>
            <div className='FilterMetaLayout__bottomRowRight'>
              {bottomContent}
            </div>
            <div className='showing'>
              {typeof this.props.totalProducts === 'number' &&
              !Number.isNaN(this.props.totalProducts)
                ? this.props.totalProducts
                : 0}{' '}
              {this.props.totalProducts === 1
                ? this.props.contentLabel === 'Classes'
                  ? 'Class'
                  : 'Program'
                : `${this.props.contentLabel}`}
            </div>
          </div>
          {/* {layoutSelector} */}
        </div>
      </div>
    )
  }
}

FilterMetaLayout.defaultProps = {
  onFixed: () => {},
  onUnfixed: () => {},
  onSort: () => {},
  totalProducts: 0
}

FilterMetaLayout.propTypes = {
  onFixed: PropTypes.func,
  onUnfixed: PropTypes.func,
  renderTopRow: PropTypes.func,
  renderBottomRowRight: PropTypes.func,
  renderBottomContent: PropTypes.func,
  totalProducts: PropTypes.number,
  filters: PropTypes.object,
  onModalClear: PropTypes.func,
  modalFilterOptions: PropTypes.object,
  order: PropTypes.string,
  onSort: PropTypes.func,
  onLayoutSelect: PropTypes.func,
  layout: PropTypes.string,
  userHasFiltered: PropTypes.bool,
  filteredLabels: PropTypes.object,
  onSelectedFilterLabelClick: PropTypes.func,
  noLowerXs: PropTypes.bool,
  sortableFields: PropTypes.array,
  excludedFilters: PropTypes.array,
  contentLabel: PropTypes.string.isRequired,
  renderMobileFilters: PropTypes.func,
  filteredItemLabels: PropTypes.array,
  onClearAll: PropTypes.func,
  applyFilter: PropTypes.array,
  loadPlanEntries: PropTypes.func,
  durationOptions: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    filteredAttributes: state.ui.planEntries.filtered,
    customDuration: state.ui.planEntries.customDuration
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addCustomDuration: ({ durationOptions }) => {
      dispatch(
        applyDurationFilter({ durationOptions, isFromClassFinderPage: true })
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterMetaLayout)
